import { apiClient } from 'modules/apiClient';
import { PricingResponse } from 'modules/subscription/types';

type SubscribeProps = {
  plan: string;
  period: string;
  paymentMethodId: string;
};

type SubscribeResponse = {
  subscriptionId: string;
  clientSecret: string;
};

const subscribe = async ({
  plan,
  period,
  paymentMethodId,
}: SubscribeProps): Promise<SubscribeResponse> => {
  const response = await apiClient.post('/v1/subscriptions/subscribe', {
    plan,
    period,
    paymentMethodId,
  });
  return response.data;
};

type CheckoutProps = {
  plan: string;
  period: string;
};

type CheckoutResponse = {
  url: string;
};

const checkout = async ({
  plan,
  period,
}: CheckoutProps): Promise<CheckoutResponse> => {
  const response = await apiClient.post('/v1/subscriptions/checkout', {
    plan,
    period,
  });
  return response.data;
};

const getPricing = async (): Promise<PricingResponse> => {
  const response = await apiClient.get('/v1/subscriptions/pricing');
  return response.data;
};

type PortalResponse = {
  url: string;
};

const getPortalLink = async (): Promise<PortalResponse> => {
  const response = await apiClient.post('/v1/subscriptions/portal');
  return response.data;
};

export const SubscriptionApi = {
  subscribe,
  checkout,
  getPricing,
  getPortalLink,
};
